import { Injectable } from '@angular/core';
import { merge, Observable } from 'rxjs';
import { AgGridApiBusService } from '../ag-grid-api-bus/ag-grid-api-bus.service';
import { map, switchMap } from 'rxjs/operators';
import { AgGridAngular } from '@ag-grid-community/angular';

@Injectable()
export class CommonGridStateChangedNotifierService {
    public readonly stateChanged$: Observable<unknown> = this.agGridApiBusService.agGridComponent.pipe(
        switchMap((agGridApi: AgGridAngular) =>
            merge(
                agGridApi.columnMoved,
                agGridApi.columnRowGroupChanged,
                agGridApi.columnPinned,
                agGridApi.columnVisible,
                agGridApi.columnResized,
                agGridApi.sortChanged
            )
        )
    );

    constructor(private agGridApiBusService: AgGridApiBusService) {}
}
